var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 15.9999C2.66699 11.2833 2.66699 8.92495 4.07073 7.35045C4.29524 7.09862 4.5427 6.86572 4.81027 6.65441C6.48317 5.33325 8.98889 5.33325 14.0003 5.33325H18.0003C23.0118 5.33325 25.5175 5.33325 27.1904 6.65441C27.458 6.86572 27.7054 7.09862 27.9299 7.35045C29.3337 8.92495 29.3337 11.2833 29.3337 15.9999C29.3337 20.7166 29.3337 23.0749 27.9299 24.6494C27.7054 24.9012 27.458 25.1341 27.1904 25.3454C25.5175 26.6666 23.0118 26.6666 18.0003 26.6666H14.0003C8.98889 26.6666 6.48317 26.6666 4.81027 25.3454C4.5427 25.1341 4.29524 24.9012 4.07073 24.6494C2.66699 23.0749 2.66699 20.7166 2.66699 15.9999Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 21.3333H15.334",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.334 21.3333L24.0007 21.3333",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 12H29.3337",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.16c076d7b58788dbfd6f6b0ae04d89ae.svg";
export { ForwardRef as ReactComponent };